import React from 'react';
import { AiOutlineMail, AiOutlinePhone, AiOutlineWarning } from 'react-icons/ai';
import { BiPrinter, BiUserCircle } from 'react-icons/bi';
import { BsAward, BsBuilding } from 'react-icons/bs';
import { Box, HStack, Icon, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../../../../../../../../../../../../../components/Spinner';
import { useGetPolicyAgent } from '../../../../../../../../../../../../../../services/policy-service';
import { getFormattedPhoneNumber } from '../../../../../../../../../../../../../../utils/formatPhoneUtil';
import { getAgencyAddressLine, getAgencyLocationLine, getAgentLicenseNumber, getAgentName } from '../../util';
import DetailItem from '../DetailItem';

const AgentDetails = ({ policyId }) => {
  const { data: agentDetails, isLoading } = useGetPolicyAgent(policyId, { enabled: !!policyId });

  if (isLoading) {
    return (
      <Box h="200px">
        <LoadingSpinner minHeight="200px" />
      </Box>
    );
  }

  return (
    <>
      { !agentDetails?.agent && (
        <Box mb={8}>
          <HStack justifyContent="center" mb={2} spacing={4}>
            <Icon
              as={AiOutlineWarning}
              color="error.primary.600"
            />
            <Text
              color="error.primary.600"
              textStyle="bodyLg600"
            >
              Agent Contact Info Missing.
            </Text>
          </HStack>
          <Text
            color="error.primary.600"
            textStyle="bodySm"
          >
            Request Policy Modification Template Unavailable.
          </Text>
        </Box>
      )}

      <HStack
        alignItems="flex-start"
        mb={8}
        spacing={24}
        textAlign="left"
      >
        <Box width="50%">
          <Text color="greyScale.800" textStyle="bodyLg500">Agent Information</Text>
          <DetailItem
            icon={BiUserCircle}
            text={getAgentName(agentDetails?.agent)}
            textStyle="bodyLg600"
          />
          <DetailItem
            icon={BsAward}
            text={getAgentLicenseNumber(agentDetails?.license)}
          />
          <DetailItem
            icon={AiOutlineMail}
            text={agentDetails?.agent?.email || 'N/A'}
          />
          <DetailItem
            href={agentDetails?.agent?.phone ? `tel:+${agentDetails?.agent?.phone}` : 'N/A'}
            icon={AiOutlinePhone}
            text={getFormattedPhoneNumber(agentDetails?.agent?.phone) || 'N/A'}
          />
        </Box>

        <Box width="50%">
          <Text color="greyScale.800" textStyle="bodyLg500">Agency Information</Text>
          <DetailItem
            icon={BsBuilding}
            text={agentDetails?.agency?.name || 'N/A'}
            textStyle="bodyLg600"
          />
          <DetailItem
            icon={BsBuilding}
            iconVisible="hidden"
            text={getAgencyAddressLine(agentDetails?.agency)}
          />
          <DetailItem
            icon={BsBuilding}
            iconVisible="hidden"
            text={getAgencyLocationLine(agentDetails?.agency)}
          />
          <DetailItem
            icon={AiOutlinePhone}
            text={getFormattedPhoneNumber(agentDetails?.agency?.phone) || 'N/A'}
          />
        </Box>

      </HStack>
    </>
  );
};

AgentDetails.propTypes = { policyId: PropTypes.number.isRequired };

export default AgentDetails;
